document.addEventListener('DOMContentLoaded', function() {
  const toggle = document.querySelector('.text-only-toggle');
  
  if (!toggle) return;

  toggle.addEventListener('click', function() {
    const currentPath = window.location.pathname;
    let textOnlyUrl = '';

    // Detectar tipo de página y construir URL apropiada
    if (currentPath === '/' || currentPath === '') {
      textOnlyUrl = '/?view=text-only';
    } else if (currentPath.includes('/collections/')) {
      textOnlyUrl = currentPath + '?view=text-only';
    } else if (currentPath.includes('/pages/')) {
      textOnlyUrl = currentPath + '?view=text-only';
    } else if (currentPath.includes('/blogs/')) {
      textOnlyUrl = currentPath + '?view=text-only';
    } else if (currentPath.includes('/products/')) {
      // Para productos, redirigir al catálogo completo en modo texto
      textOnlyUrl = '/collections/all?view=text-only';
    } else {
      // Por defecto, ir al home en modo texto
      textOnlyUrl = '/?view=text-only';
    }

    window.location.href = textOnlyUrl;
  });
});